<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { defineProps, defineEmits, reactive, ref, onMounted, computed, PropType } from "vue";
import { formatAmount, MONTHS_FR } from "@/utils";
import axios from "axios";
import moment from "moment";

interface PlanMensuel {
    columns: string[];
    data: {
        _DECAISSEMENT_: number[],
        _FOND_RISQUE_: number[],
        _CREDITS_MENSUELS_: number[],
        _FRAIS_MENSUELS_: number[],
        _RENFOUREMENT_: number[],
        _REVOLVING_: number[],
        _CASHBACK_TVA_: number[],
        _UTILISATION_: number[],
        _UTILISATION_INDEX_: number[],
        _UTILISATION_CUMUL_: number[],
        _DEPENSES_MENSUELS_: number[],
        _CREDIT_EPARGNE_: number[],
        _SOLDE_TOTAL_CASHFLOW_: number[],
        _UTILISATION_BY_INDEX_: number[],
        _PROGRESSIVE_: number[],
    };
    totals: {
        _DECAISSEMENT_: number,
        _FOND_RISQUE_: number,
        _CREDITS_MENSUELS_: number,
        _FRAIS_MENSUELS_: number,
        _RENFOUREMENT_: number,
        _REVOLVING_: number,
        _CASHBACK_TVA_: number,
        _UTILISATION_: number,
        _UTILISATION_INDEX_: number,
        _UTILISATION_CUMUL_: number,
        _DEPENSES_MENSUELS_: number,
        _CREDIT_EPARGNE_: number,
        _SOLDE_TOTAL_CASHFLOW_: number,
        _UTILISATION_BY_INDEX_: number,
        _PROGRESSIVE_: number,
    };
}

const props = defineProps<{
    planMensuel: PlanMensuel;
    title: string;
}>();
const loading = ref(false);
const error = ref(null as string | null);

/*const title = computed(() => {
    if (!props.dateDebut || !props.dateFin) { return ''; }
    const dateDebutM = moment(props.dateDebut);
    const dateFinM = moment(props.dateFin);

    return `Année ${(props.offset + 1)} / ${MONTHS_FR[dateDebutM.month()]} ${dateDebutM.format('YYYY')} - ${MONTHS_FR[dateFinM.month()]} ${dateFinM.format('YYYY')}`;
});*/

</script>
<template>
    <div>
        <div class="s20 widget shadow-100 px-5 py-4 text-center" v-if="loading"><!-- widget shadow-100 fill -->
            <span class="font-semibold text-xl">
                Chargement des données...
            </span>
        </div>

        <div class="s20 widget shadow-100 px-5 py-4 text-center" v-else-if="!planMensuel"><!-- widget shadow-100 fill -->
            <span class="font-semibold text-xl">
                {{ error ?? 'Aucun plan mensuel disponible' }}
            </span>
        </div>

        <div v-else>
            <div class="s20 widget shadow-100 pb-1" v-if="planMensuel.data"><!-- widget shadow-100 fill -->

                <div class="mt-6 ml-4 mb-5 collapse-open active">
                    <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                        <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                        <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                        {{ props.title }}
                    </span>
                </div>
                
                <div class="s20 pb-7 collapse-content active">
                    <div class="container-full-2 s20 mb-5">
                        <div class="s7"><h4 class="font-semibold mt-3">{{ title }}</h4></div>
                        <div class="s13 flex gap-2 justify-content-right">
                            <button class="btn black normal justify-content-center mx-0 btn-filtre">
                                <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                                <span>Exporter PDF</span>
                            </button>
                            <button class="btn black normal justify-content-center mx-0 btn-filtre">
                                <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                                <span>Exporter Excel</span>
                            </button>
                        </div>
                    </div>

                    <table class="table separator skin1 sm selection text-right">
                        <thead>
                            <tr>
                                <th></th>
                                <th>1</th>
                                <th>2</th>
                                <th>3</th>
                                <th>4</th>
                                <th>5</th>
                                <th>6</th>
                                <th>7</th>
                                <th>8</th>
                                <th>9</th>
                                <th>10</th>
                                <th>11</th>
                                <th>12</th>
                                <th class="font-semibold pr-5">Total</th>
                            </tr>
                            <tr>
                                <th class="mode text-left py-5 pl-5">Mois</th>
                                <th v-for="(column, index) of planMensuel.columns" :key="index">{{ column }}</th>
                                <th class="font-semibold pr-5"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="mode text-left pl-5">Décaissement</td>
                                <td v-for="(data, index) of planMensuel.data['_DECAISSEMENT_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold pr-5">{{ formatAmount(planMensuel['totals']['_DECAISSEMENT_']) }}</td>
                            </tr>
                            <tr>
                                <td class="mode text-left pl-5">25% Fond de risque</td>
                                <td class="text-red" v-for="(data, index) of planMensuel.data['_FOND_RISQUE_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold text-red pr-5">{{ formatAmount(planMensuel['totals']['_FOND_RISQUE_']) }}</td>
                            </tr>
                            <tr>
                                <td class="mode text-left pl-5">Crédits Mensuels</td>
                                <td class="" v-for="(data, index) of planMensuel.data['_CREDITS_MENSUELS_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold pr-5">{{ formatAmount(planMensuel['totals']['_CREDITS_MENSUELS_']) }}</td>
                            </tr>
                            <tr>
                                <td class="mode text-left pl-5">Frais mensuels: 3%</td>
                                <td class="text-red" v-for="(data, index) of planMensuel.data['_FRAIS_MENSUELS_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold text-red pr-5">{{ formatAmount(planMensuel['totals']['_FRAIS_MENSUELS_']) }}</td>
                            </tr>
                            <tr>
                                <td class="mode text-left pl-5">Remboursement: 50%</td>
                                <td class="text-red" v-for="(data, index) of planMensuel.data['_RENFOUREMENT_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold text-red pr-5">{{ formatAmount(planMensuel['totals']['_RENFOUREMENT_']) }}</td>
                            </tr>
                            <tr>
                                <td class="mode text-left pl-5">Revolving Recharge</td>
                                <td v-for="(data, index) of planMensuel.data['_REVOLVING_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold pr-5">{{ formatAmount(planMensuel['totals']['_REVOLVING_']) }}</td>
                            </tr>
                            <tr>
                                <td class="mode text-left pl-5">Cash-Back TVA</td>
                                <td v-for="(data, index) of planMensuel.data['_CASHBACK_TVA_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold pr-5">{{ formatAmount(planMensuel['totals']['_CASHBACK_TVA_']) }}</td>
                            </tr>
                            <tr>
                                <td class="text-lg font-semibold py-5 text-left pl-5">Utilisation</td>
                                <td v-for="(data, index) of planMensuel.data['_UTILISATION_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="text-lg font-semibold text-red pr-5">{{ formatAmount(planMensuel['totals']['_UTILISATION_']) }}</td>
                            </tr>
                            <tr>
                                <td class="font-bold text-left pl-5">Index Utilisation</td>
                                <td v-for="(data, index) of planMensuel.data['_UTILISATION_INDEX_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="text-lg font-semibold text-red pr-5">{{ formatAmount(planMensuel['totals']['_UTILISATION_INDEX_']) }}</td>
                            </tr>
                            <tr>
                                <td class="font-bold text-left pl-5">Index Cumulé</td>
                                <td v-for="(data, index) of planMensuel.data['_UTILISATION_CUMUL_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold pr-5">{{ formatAmount(planMensuel['totals']['_UTILISATION_CUMUL_']) }}</td>
                            </tr>
                            <tr>
                                <td class="mode text-left pl-5">Depenses Mensuels</td>
                                <td class="text-red" v-for="(data, index) of planMensuel.data['_DEPENSES_MENSUELS_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold text-red pr-5">{{ formatAmount(planMensuel['totals']['_DEPENSES_MENSUELS_']) }}</td>
                            </tr>
                            <tr style="background-color: #e7ffd6;">
                                <td class="font-semibold text-blue text-left py-4 pl-5">Crédit Epargne</td>
                                <td class="font-semibold text-blue" v-for="(data, index) of planMensuel.data['_CREDIT_EPARGNE_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold text-blue pr-5">{{ formatAmount(planMensuel['totals']['_CREDIT_EPARGNE_']) }}</td>
                            </tr>
                            <tr>
                                <td class="font-semibold text-left py-5 pl-5">Solde Total Cash Flow</td>
                                <td class="font-semibold" v-for="(data, index) of planMensuel.data['_SOLDE_TOTAL_CASHFLOW_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="font-semibold pr-5"></td>
                            </tr>
                            <tr style="background-color: #eefde3;">
                                <td class="text-lg font-semibold text-green text-left py-5 pl-5">Utilisation By Index</td>
                                <td class="text-lg font-semibold text-green" v-for="(data, index) of planMensuel.data['_UTILISATION_BY_INDEX_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="text-lg font-semibold text-green pr-5">{{ formatAmount(planMensuel['totals']['_UTILISATION_BY_INDEX_']) }}</td>
                            </tr>
                            <tr>
                                <td class="text-lg font-semibold text-blue text-left py-5 pl-5">Progressive</td>
                                <td class="text-lg font-semibold text-blue" v-for="(data, index) of planMensuel.data['_PROGRESSIVE_']" :key="index">{{ formatAmount(data) }}</td>
                                <td class="text-lg font-semibold text-blue pr-5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="clear-both h-30"></div>
</template>